// -----------------------------------------------------------------------------
// 📌 App.tsx — Full Project Routing (Cleaned + Organized + Fully Commented)
// -----------------------------------------------------------------------------

import LibraryListPage from "./Additional_components/Additional/Elibrary/elibrary";
import AddElibraryPage from "./Admin_Panel/Dashboard/E-Library/Create/AddPage";
import EditLibrary from "./Admin_Panel/Dashboard/E-Library/Update/EditLibrary";
import LibraryList from "./Admin_Panel/Dashboard/E-Library/Update/LibraryList";
import SubtopicForm from "./Admin_Panel/Dashboard/E-Library/Update/SubtopicForm";
import EditSubtopic from "./Admin_Panel/Dashboard/E-Library/Update/UpdatePage";
// ---------------------------------------------
// 📚 OLD E-LIBRARY SYSTEM (Legacy)
// ---------------------------------------------
import Elibrary from "./Admin_Panel/Dashboard/E-Library/e-library";
// ---------------------------------------------
// 📊 HOMEPAGE SETTINGS & CONTENT UPDATE
// ---------------------------------------------
import Updatedates from "./Admin_Panel/Dashboard/EditHomepage/UpdateDate/Update-Dates";
import UpdateGif from "./Admin_Panel/Dashboard/EditHomepage/UpdateGif/Update-Gif";
import UpdateValuesTable from "./Admin_Panel/Dashboard/EditHomepage/UpdateHike/Update-Value";
import Updatetestinomials from "./Admin_Panel/Dashboard/EditHomepage/UpdateTestimonials/updatetestinomials";
import Mainpage_home from "./Admin_Panel/Dashboard/EditHomepage/mainpage_home";
import GenerateAzureCertificate from "./Admin_Panel/Dashboard/GenerateCertificate/Azure-Certificate/GenerateAzureCertificate";
import Certificatedata from "./Admin_Panel/Dashboard/GenerateCertificate/Cerificate-Data/Certificate-data";
import GeneratePythonCertificate from "./Admin_Panel/Dashboard/GenerateCertificate/Python-Certificate/GeneratePythonCertificate";
import GenerateSQLCertificate from "./Admin_Panel/Dashboard/GenerateCertificate/SQL-Certificate/GenerateSQLCertificate";
import VerificationForm from "./Admin_Panel/Dashboard/GenerateCertificate/Verification/Verify";
// ---------------------------------------------
// 🏆 CERTIFICATES
// ---------------------------------------------
import Mainpage_certificate from "./Admin_Panel/Dashboard/GenerateCertificate/mainpage_certificate";
// ---------------------------------------------
// 🧑‍� ADMIN DASHBOARD
// ---------------------------------------------
import Latestjob from "./Admin_Panel/Dashboard/Latest-Job/Latestjob";
// ---------------------------------------------
// 📰 BLOG + CHAPTER MANAGEMENT
// ---------------------------------------------
 
import Createnew from "./Admin_Panel/Dashboard/Update/AddNewChapter";
import UpdateChapterPage from "./Admin_Panel/Dashboard/Update/UpdateChapter";
import UpdateBookPage from "./Admin_Panel/Dashboard/Update/Updatebook";
import UpdateLibraryPage from "./Admin_Panel/Dashboard/Update/updateLibrary";
import ViewCorporateData from "./Admin_Panel/Dashboard/ViewFormsData/View-CorporateTrainig/ViewCorporateTraining";
import ViewHireFormUS from "./Admin_Panel/Dashboard/ViewFormsData/View-HireFromUS/ViewHirefromUS";
// ---------------------------------------------
// 📄 FORM DATA VIEWS
// ---------------------------------------------
import ViewFormData from "./Admin_Panel/Dashboard/ViewFormsData/ViewFormData";
import CreateBookPage from "./Admin_Panel/Dashboard/createBook/createBook";
import CreateChapter from "./Admin_Panel/Dashboard/createChapter/createChapter";
// ---------------------------------------------
// � E-LIBRARY | New Multi-Level Flow
// ---------------------------------------------
import CreateLibrary from "./Admin_Panel/Dashboard/createLibrary/createLibrary";
import Dashboard from "./Admin_Panel/Dashboard/dashboard/dashboard";
import MyState from "./Backend/Firebase/data/myState";
import { Footer } from "./Main_Components/Footer/footer";
// ---------------------------------------------
// 🌐 PUBLIC COMPONENTS
// ---------------------------------------------
import Home from "./Main_Components/Header/Home/home";
import { Toaster } from "react-hot-toast";
import { Route, Routes } from "react-router-dom";

// -----------------------------------------------------------------------------
// 🚀 APPLICATION ROOT
// -----------------------------------------------------------------------------

function App() {
  return (
    <>
   
      <MyState>
        {/* ------------------------------------------------------------------ */}
        {/* 🌐 ROUTING START                                                  */}
        {/* ------------------------------------------------------------------ */}
        <Routes>
          {/* --------------------------------------------- */}
          {/* 🏠 PUBLIC ROUTES                              */}
          {/* --------------------------------------------- */}
          <Route path="/" element={<Home />} />
          
           <Route path="/Dashboard" element={< Dashboard/>} />
          <Route path="/elibrayshow" element={<LibraryListPage />} />
          <Route
            path="/certificate-validation"
            element={<VerificationForm />}
          />

          {/* ================================================================== */}
          {/* 📚 NEW GENERATION — MULTI-LEVEL E-LIBRARY SYSTEM                  */}
          {/* ================================================================== */}

          {/* 1️⃣ Create Library */}
          <Route path="/createLibrary" element={<CreateLibrary />} />

          {/* 2️⃣ Create Book inside selected Library */}
          <Route
            path="/createLibrary/:librarySlug/create-book"
            element={<CreateBookPage />}
          />

          {/* 3️⃣ Create Chapter inside selected Book */}
          <Route
            path="/createLibrary/:librarySlug/create-book/:bookSlug/create-chapter"
            element={<CreateChapter />}
          />

          {/* ================================================================== */}
          {/* 📚 OLD LEGACY E-LIBRARY SYSTEM                                   */}
          {/* ================================================================== */}

          <Route path="/elibrary" element={<Elibrary />} />
          <Route path="/elibrary/create" element={<AddElibraryPage />} />
          <Route path="/elibrary/update" element={<LibraryList />} />
          <Route path="/elibrary/update/:id" element={<EditLibrary />} />
          <Route path="/elibrary/:id/subtopic/new" element={<SubtopicForm />} />
          <Route
            path="/elibrary/:id/subtopic/:subId/edit"
            element={<EditSubtopic />}
          />

          {/* ================================================================== */}
          {/* 📰 BLOG & CHAPTER MANAGEMENT                                      */}
          {/* ================================================================== */}

          {/* <Route path="/updatechapters/:bookSlug" element={<UpdateChapter />} /> */}
          {/* ✏ Update Book */}
          <Route path="/update/:librarySlug" element={<UpdateLibraryPage />} />
          <Route
            path="/updatebook/:librarySlug/:bookSlug"
            element={<UpdateBookPage />}
          />
          <Route
            path="/updatechapter/:librarySlug/:bookSlug/:chapterSlug"
            element={<UpdateChapterPage />}
          />

          <Route path="/createnew/:id" element={<Createnew />} />

          {/* ================================================================== */}
          {/* 🏆 CERTIFICATE MANAGEMENT                                         */}
          {/* ================================================================== */}

          <Route
            path="/generate-certificate"
            element={<Mainpage_certificate />}
          />
          <Route
            path="/generate-certificate/certificate-data"
            element={<Certificatedata />}
          />
          <Route
            path="/generate-certificate/Azure"
            element={<GenerateAzureCertificate />}
          />
          <Route
            path="/generate-certificate/Python"
            element={<GeneratePythonCertificate />}
          />
          <Route
            path="/generate-certificate/SQL"
            element={<GenerateSQLCertificate />}
          />

          {/* ================================================================== */}
          {/* 🏡 HOMEPAGE CONTENT UPDATE                                        */}
          {/* ================================================================== */}

          <Route path="/edit-dates" element={<Updatedates />} />
          <Route path="/update-ocassion" element={<UpdateGif />} />
          <Route path="/edit-values" element={<UpdateValuesTable />} />
          <Route path="/edit-testinomials" element={<Updatetestinomials />} />
          <Route path="/edithomepage" element={<Mainpage_home />} />

          {/* ================================================================== */}
          {/* 🧾 FORM DATA VIEWS                                                */}
          {/* ================================================================== */}

          <Route
            path="/dashboard/Admin-Pannel/View-Form-Data"
            element={<ViewFormData />}
          />
          <Route
            path="/View-Form-Data/View-Hire-From-US"
            element={<ViewHireFormUS />}
          />
          <Route
            path="/View-Form-Data/View-Corporate-Training"
            element={<ViewCorporateData />}
          />

          {/* ================================================================== */}
          {/* 🧑‍💼 ADMIN DASHBOARD & JOBS                                       */}
          {/* ================================================================== */}

          <Route path="/latestjob" element={<Latestjob />} />
          <Route path="/dashboard" element={<Dashboard />} />
        </Routes>

        {/* ------------------------------------------------------------------ */}
        {/* 🔔 Toast Messages + Footer                                         */}
        {/* ------------------------------------------------------------------ */}
        <Toaster />
        <Footer />
      </MyState>
    </>
  );
}

export default App;
